import type { AuthResponse } from "@/types";
import type { User, UserType } from "@/types/user";

type SwitchSessionDeps = {
    updateUser: (user: Partial<User>) => void;
    setTokens: (tokens: { accessToken: string; refreshToken: string }) => void;
};

export function applySwitchSession(
    payload: AuthResponse,
    deps: SwitchSessionDeps
): UserType {
    const { user, access_token, refreshToken } = payload.data;
    deps.updateUser(user);
    deps.setTokens({ 
        accessToken: access_token, 
        refreshToken 
    });
    return user.userType;
}